// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"797fc1ba","453":"979ddd99","732":"3ef70417","977":"f996d816"}[chunkId] + ".chunk.js";
};